import ApiClient from '@/services/apiClient';

export default class Installer {
  id;
  email;
  name;
  first_name;
  company_name;
  picture;
  mobile_phone_number;
  alert;
  mfa = "none";    //"none", "email", "sms", "totp", "push" (approval on an enrolled phone)
  password = "";
  confirmPassword = "";
  supervisor;
  group_admin = false;
  can_create = false;

  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Installer();
      obj.id = ApiClient.convertToType(data['id'], 'Integer');
      obj.email = ApiClient.convertToType(data['email'], 'String');
      obj.name = ApiClient.convertToType(data['name'], 'String');
      obj.first_name = ApiClient.convertToType(data['first_name'], 'String');
      obj.company_name = ApiClient.convertToType(data['company_name'], 'String');
      obj.picture = ApiClient.convertToType(data['picture'], 'String');
      obj.mobile_phone_number = ApiClient.convertToType(data['mobile_phone_number'], 'String');
      obj.alert = ApiClient.convertToType(data['alert'], 'Boolean');
      obj.mfa = ApiClient.convertToType(data['mfa'], 'String');
      obj.supervisor = ApiClient.convertToType(data['supervisor'], 'Integer') || 0;
      obj.group_admin = ApiClient.convertToType(data['group_admin'], 'Boolean');
      obj.can_create = ApiClient.convertToType(data['can_create'], 'Boolean');
    }
    return obj;
  }

  toJSON() {
    const json = {
      email: this.email,
      mobile_phone_number: this.mobile_phone_number,
      mfa: this.mfa,
      name: this.name,
      company_name: this.company_name,
      first_name: this.first_name,
      alert: this.alert,
    };

    if (this.password) {
      json.password = this.password;
    }

    if (this.picture != null && !this.picture.startsWith("http")) {
      if (this.picture.length === 0) {
        json.picture = "";
      } else {
        json.picture = this.picture.split(',')[1];
      }
    }

    if(this.code) {
      json.code = this.code;
    }

    if(this.totp) {
      json.totp = this.totp;
    }

    return json;
  }

  clone() {
    return Installer.constructFromObject(this);
  }

  update(updatedInstaller, picture) {
    updatedInstaller.picture = picture;
    Installer.constructFromObject(updatedInstaller, this);
  }

  get initials() {
    return `${this.first_name.substring(0, 1).toUpperCase()}${this.name.substring(0, 1).toUpperCase()}`;
  }

  get full_name() {
    return `${this.first_name} ${this.name}`;
  }
}